// minimal cart count refresh
document.addEventListener('DOMContentLoaded',()=>{
  fetch('/cart.js').then(r=>r.json()).then(c=>{
    document.querySelectorAll('[data-cart-count]').forEach(el=>{
      el.textContent=c.item_count;
      el.style.display=c.item_count>0?'inline-flex':'none';
    });
  }).catch(()=>{});
});
